var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditableTableItem',{attrs:{"blueish":true,"remove-icon":true,"value":_vm.value},on:{"save":_vm.saveNewValue}},[_vm._v("\n  "+_vm._s(`€ ${_vm.value}`)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }